import script from "./SelectBox.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectBox.vue?vue&type=script&setup=true&lang=js"

import "./SelectBox.vue?vue&type=style&index=0&id=37b3bac8&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37b3bac8"]])

export default __exports__